import { render } from "./ReturnIndex.vue?vue&type=template&id=5425b6dc&scoped=true"
import script from "./ReturnIndex.vue?vue&type=script&lang=js"
export * from "./ReturnIndex.vue?vue&type=script&lang=js"

import "./ReturnIndex.vue?vue&type=style&index=0&id=5425b6dc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5425b6dc"]])

export default __exports__